enum TipoPlanejamentoEnum {
	META = "META",
	LIMITE = "LIMITE",
}

export { TipoPlanejamentoEnum };
